import { useHTTP } from '@yiban-shared/plugins/http';
import * as BalmUIPro from './balm-ui-pro';
import getModelStoreMixin from './mixin';

export default getModelStoreMixin(useHTTP, BalmUIPro);
